import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
import SemDados from '../SemDados';
import { months } from '../../data/sampleData';

const EvolucaoSolicitacoesVarejo = (props) => {
  const { data, hasAnnotation } = props;

  const titulo = 'EVOLUÇÃO DE SOLICITAÇÕES - FOOD VAREJO';

  const canais = ['food & VAREJO'];

  if (
    !data ||
    Object.keys(data).length === 0 ||
    !Object.keys(data).includes(canais[0])
  )
    return <SemDados titulo={titulo} />;

  const anos = Object.keys(data[canais[0]].data);
  const meses = [];
  const values = {};

  let maxValue = 1;

  const calculateAnnotation = (series) => {
    if (anos.length < 2 || !hasAnnotation) return [];

    const tmpAnnotationPoints = [];

    const ultimoMes = series?.[anos.length - 1]?.data?.[meses.length - 1];
    const penultimoMes = series?.[anos.length - 2]?.data?.[meses.length - 1];
    const variacao = ((ultimoMes - penultimoMes) / penultimoMes) * 100;
    const labelColor = variacao > 0 ? '#008000' : '#FF0000';

    tmpAnnotationPoints.push({
      x: meses?.[meses.length - 1],
      y: series?.[anos.length - 1]?.data?.[meses.length - 1] ?? 0,
      yAxisIndex: 0,
      seriesIndex: anos.length - 1,
      marker: {
        size: 0,
      },
      label: {
        borderColor: undefined,
        text: Number.isFinite(variacao)
          ? `${variacao > 0 ? '+' : ''}${variacao.toFixed(0)}%`
          : 'N/A',
        textAnchor: 'start',
        offsetX: -4,
        offsetY: -15,
        style: {
          background: 'transparent',
          color: labelColor,
          fontSize: '12px',
          fontWeight: 700,
        },
      },
    });

    return tmpAnnotationPoints;
  };

  const calculateSeries = () => {
    const tmpSeries = [];
    if (anos.length === 0) {
      return [];
    }
    months.forEach((mes, i) => {
      let check = false;
      anos.forEach((ano) => {
        if (data[canais[0]].data[ano][i] !== null) {
          maxValue = Math.max(maxValue, data[canais[0]].data[ano][i]);
          check = true;
        }
      });
      if (check) {
        anos.forEach((ano) => {
          values[ano] = [...(values[ano] || []), data[canais[0]].data[ano][i]];
        });
        meses.push(`${mes.slice(0, 3)}.`);
      }
    });
    anos.forEach((ano) => {
      tmpSeries.push({
        name: ano,
        data: values[ano],
      });
    });
    return tmpSeries;
  };

  const series = calculateSeries();

  const options = {
    annotations: {
      points: calculateAnnotation(series),
    },
    legend: {
      showForSingleSeries: true,
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      floating: false,
      offsetX: 0,
      offsetY: 7,
    },
    colors: ['#fad086', '#faa306'],
    plotOptions: {
      bar: {
        hideZeroBarsWhenGrouped: false,
        horizontal: false,
        dataLabels: {
          position: 'top',
        },
        colors: {},
      },
    },
    stroke: {
      colors: ['transparent'],
      width: 4,
    },
    xaxis: {
      categories: [...meses],
      show: true,
      position: 'top',
      labels: {
        show: true,
        offsetY: 10,
        style: {
          fontWeight: 600,
        },
      },
      axisBorder: {
        color: '#d7d7d7',
      },
      axisTicks: {
        show: true,
        height: 20,
        offsetX: 0,
        offsetY: 0,
      },
    },
    yaxis: {
      max: maxValue * 1.1,
      show: false,
    },
    grid: {
      padding: {
        bottom: -38,
        top: 15,
      },
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    chart: {
      id: 'can-solicitacoes',
      parentHeightOffset: 5,
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      hideOverflowingLabels: false,
      textAnchor: 'middle',
      offsetX: 0,
      offsetY: -19,
      formatter: (value) => {
        return value === null ? 0 : `${value}`;
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      shared: false,
      followCursor: true,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return `<div class="arrow_box">
            <span>
              Mês de Data Criação: <span id="data">${meses[dataPointIndex]}</span>
            </span>
            <span>
              Ano de Data Criação: <span id="data">${anos[seriesIndex]}</span>
            </span>
            <span>
              Contagem Distinta de Solicitação: <span id="data">${series[seriesIndex][dataPointIndex]}</span>
            </span>
          </div>
          `;
      },
    },
  };

  return (
    <div className="grafico">
      <div className="grafico-titulo">
        <span style={{ fontSize: '0.9rem' }}>{titulo}</span>
      </div>
      <Chart options={options} series={series} type="bar" height="300" />
    </div>
  );
};

export default EvolucaoSolicitacoesVarejo;
